<template>
  <div class="left padding">
    <h2 class="titles">{{ this.$t("altaImpago.tipoReclamacion") }}</h2>
    <p class="explanation">
      {{ this.$t("altaImpago.textos.tipoReclamacionExplicacion") }}
    </p>
    <template v-for="tipoProducto in tiposProducto">
      <CardReclamacion
        :key="tipoProducto.codigo"
        :tipoContrato="tipoProducto.codigo"
        :precio="tipoProducto.tarifa"
        :nombre="tipoProducto.nombre"
        :descripcion="tipoProducto.descripcion"
        :tipo="tipoProducto.tipo"
      />
    </template>
  </div>
</template>

<script>
import CardReclamacion from "@/components/portal-cliente/Utils/CardReclamacion.vue";
import { QUERY_PRODUCTOS_ACTIVOS_INCLUSION } from "@/graphQLQueries/TipoProductoQueries";

export default {
  name: "ImpagoMenu",
  components: {
    CardReclamacion,
  },
  data() {
    return {
      tiposProducto: [],
    };
  },
  apollo: {
    tiposProducto: {
      query: QUERY_PRODUCTOS_ACTIVOS_INCLUSION,
      update(data) {
        return data.listaProductosInclusionActivosIciredPortalClientes;
        //.sort((a,b) => (a.tarifa > b.tarifa) ? 1 : ((b.tarifa > a.tarifa) ? -1 : 0));
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.padding {
  padding: 2%;
}

.removeBoxShadow {
  box-shadow: none !important;
}

.claimBorderBottom {
  border-bottom: 1px solid #cccccc;
}

.explanation {
  color: #b7b8bb;
}
</style>